import { BASE_PATH, ASSET_DOMAIN_URL } from 'gatsby-env-variables';

export const incredNews = [
  {
    label: 'News Section',
    data: [
      {
        Img: 'business-std.png',
        text: 'Business Standard',
        Date: 'January 24, 2024',
        content: `Fintech unicorn InCred Finance doubles profit to Rs 298 crore in 9MFY24`,
        link: 'https://www.business-standard.com/companies/news/fintech-unicorn-incred-finance-doubles-profit-to-rs-298-crore-in-9mfy24-124012400914_1.html',
      },
      {
        Img: 'BW-people-logo.jpg',
        text: 'BWPeople',
        Date: 'January 12, 2024',
        content: `Kamlesh Dangi, Group Head- HR at InCred believes that one can define culture as an environment created by the shared values, beliefs and attitudes of employees.`,
        link: 'https://bwpeople.businessworld.in/article/-Shared-Values-Shape-Organisational-Culture-/12-01-2024-505815/',
      },
      {
        Img: 'Inc4.jpg',
        text: 'Inc42',
        Date: 'December 25, 2023',
        content: `Fintech startup InCred on Monday (December 25) said its lending arm turned unicorn after raising a $60 Mn`,
        link: 'https://inc42.com/buzz/incred-closes-60-mn-series-d-round-becomes-second-unicorn-of-2023/amp/',
      },
      {
        Img: 'moneycontrol.jpg',
        text: 'Moneycontrol',
        Date: 'December 25, 2023',
        content: `Following the fresh capital infusion, InCred has been valued at USD 1.04 billion`,
        link: 'https://www.moneycontrol.com/news/business/incred-turns-unicorn-after-raising-60-mn-in-funding-round-11953491.html/amp/',
      },
      {
        Img: 'businessLine.png',
        text: 'The Hindu BusinessLine',
        Date: 'December 25, 2023',
        content: `The equity capital of ₹500 crore will be deployed across InCred’s core business verticals`,
        link: 'https://www.thehindubusinessline.com/companies/increds-lending-business-turns-unicorn-after-raising-60-m-in-series-d-round/article67673786.ece/amp/',
      },
      {
        Img: 'business-std.png',
        text: 'Business Standard',
        Date: 'December 25, 2023',
        content: `Fintech firm InCred on Monday announced the list of investors who infused Rs 500 crore`,
        link: 'https://www.business-standard.com/companies/start-ups/incred-announces-list-of-investors-injecting-rs-500-crore-in-company-123122500684_1.html',
      },
      {
        Img: 'livemint.jpg',
        text: 'Livemint',
        Date: 'December 25, 2023',
        content: `InCred has achieved a valuation exceeding 1 billion dollars, marking its status as the latest unicorn in the country.`,
        link: 'https://www.livemint.com/companies/news/incred-raises-rs-500-crore-funding-to-become-india-s-second-unicorn-in-2023-11703513522870.html',
      },
      {
        Img: 'economic-time.jpeg',
        text: 'The Economic Times',
        Date: 'December 25, 2023',
        content: `Non-banking lending company InCred Finance has closed its series D funding round securing $60 million`,
        link: 'https://m.economictimes.com/tech/funding/incred-secures-60-million-in-funding-joins-unicorn-club/amp_articleshow/106268433.cms',
      },
      {
        Img: 'expressComputer.jpg',
        text: 'Express Computer',
        Date: 'November 23, 2023',
        content: `Ashwin Sekar, Chief Product & Technology Officer, lnCred shares how they’re using cool tech to make financial services better—faster, safer, and more personalised.`,
        link: 'https://www.expresscomputer.in/news/the-convergence-of-cloud-content-and-edge-to-serve-customers-effectively/106017/',
      },
      {
        Img: 'economic-time.jpeg',
        text: 'The Economic Times',
        Date: 'November 15, 2023',
        content: `Small businesses play a critical role in shaping India's economy and also generate jobs for millions.`,
        link: 'https://economictimes.indiatimes.com/small-biz/sme-sector/how-digital-lenders-are-making-loan-application-process-easy-for-msmes/articleshow/105225107.cms',
      },
      {
        Img: 'Inc4.jpg',
        text: 'Inc42',
        Date: 'November 09, 2023',
        content: 'InCred Closing $60 Mn Series D Round, To Be Second Unicorn Of 2023',
        link: 'https://inc42.com/buzz/incred-closing-60-mn-series-d-round-to-be-second-unicorn-of-2023/',
      },
      {
        Img: 'livemint.jpg',
        text: 'Livemint',
        Date: 'November 09, 2023',
        content: 'InCred Finance raises ₹500 crore, turns unicorn',
        link: 'https://www.livemint.com/companies/start-ups/incred-finance-raises-rs-500-crore-turns-unicorn-11699529401379.html',
      },
      {
        Img: 'yourstory.png',
        text: 'YOURSTORY',
        Date: 'November 09, 2023',
        content: 'INCRED SECURES COMMITMENT OF RS 500 CR; TO JOIN UNICORN CLUB',
        link: 'https://yourstory.com/2023/11/incred-secures-commitment-of-rs-500-cr-to-join-unicorn-club',
      },
      {
        Img: 'BFSI.png',
        text: 'BFSI',
        Date: 'October 14, 2023',
        content:
          'The NCD issue has a base size of ₹150 crore and an option for additional subscription of ₹150 crore, the non-banking financial company said on Friday.',
        link: 'https://bfsi.economictimes.indiatimes.com/news/nbfc/incred-fin-plans-to-raise-up-to-rs-300-cr-via-ncds/104420470',
      },
      {
        Img: 'economic-time.jpeg',
        text: 'THE ECONOMIC TIMES',
        Date: 'October 14, 2023',
        content:
          'InCred Financial Services aims to raise up to ₹300 crore through a public issue of non-convertible debentures (NCD), with the sale opening on October 25 and closing on November 7.',
        link: 'https://economictimes.indiatimes.com/markets/bonds/incred-fin-plans-to-raise-up-to-rs-300-cr-via-ncds/articleshow/104415700.cms',
      },
      {
        Img: 'moneycontrol.jpg',
        text: 'Moneycontrol',
        Date: 'October 13, 2023',
        content: "The NCDs are rated 'A+' with a 'Stable' outlook by CRISIL. The company is offering a coupon rate of up to 10.30 percent",
        link: 'https://www.moneycontrol.com/news/business/incred-financial-services-to-raise-up-to-rs-300-cr-via-public-issue-of-ncds-11527781.html',
      },
      {
        Img: 'businessLine.png',
        text: 'The Hindu BusinessLine',
        Date: 'October 13, 2023',
        content:
          'InCred Financial Services Ltd (IFCL) on Friday announced a public issue of secured, rated, listed, redeemable, non-convertible debentures (NCDs) aggregating up to ₹300 crore ',
        link: 'https://www.thehindubusinessline.com/markets/incred-financial-services-to-raise-up-to-300-cr-via-ncds/article67416347.ece',
      },
      {
        Img: 'people-mattters.jpeg',
        text: 'Moneycontrol',
        Date: 'August 01, 2023',
        content: 'Employee engagement and well-being are reciprocal, says Kamlesh Dangi, InCred...',
        link: 'https://www.peoplematters.in/article/employee-relations/employee-engagement-and-well-being-are-reciprocal-says-kamlesh-dangi-incred-38590',
      },
      {
        Img: 'OUTLOOK-START.png',
        text: 'Outlook',
        Date: 'July 04, 2023',
        content: 'InCred Finance eyes to showcase its business loan product in a co-branded promotional campaign... ',
        link: 'https://startup.outlookindia.com/sector/fintech/incred-finance-and-tarla-dalal-biopic-collaborate-to-promote-entrepreneurial-spirit-news-8811',
      },
      {
        Img: 'Financial-Express.jpeg',
        text: 'Financial Express',
        Date: 'July 03, 2023',
        content: 'InCred Financial Services Limited (InCred Finance) has announced partnership... ',
        link: 'https://www.financialexpress.com/business/brandwagon-incred-finance-collaborates-with-tarla-dalal-biopic-to-promote-entrepreneurship-3152946/',
      },
      {
        Img: 'BWMARKET.png',
        text: 'BW Marketing',
        Date: 'July 03, 2023',
        content: 'The film celebrates the aspirations of small company owners across India and symbolises... ',
        link: `${BASE_PATH}/docs/InCred - Finance - magazine.pdf`,
      },
      {
        Img: 'economic-time.jpeg',
        text: 'THE ECONOMIC TIMES',
        Date: 'July 01, 2023',
        content: 'Kamlesh Dangi, Group Head - Human Resources at InCred, believes that maintaining physical...',
        link: 'https://economictimes.indiatimes.com/markets/expert-view/mind-over-money-this-hr-head-devotes-4-5-hours-to-sports-every-weekend-to-meet-fitness-goals/articleshow/101411064.cms?from=mdr',
      },
      {
        Img: 'HR-KATHA.png',
        text: 'HR KATHA',
        Date: 'June 27, 2023',
        content: "By aligning team members' roles with their personalities, companies can harness the full potential of their teams...",
        link: 'https://www.hrkatha.com/features/how-organising-teams-with-different-personalities-can-be-beneficial/',
      },
      {
        Img: 'Financial-Express.jpeg',
        text: 'Financial Express ',
        Date: 'June 22, 2023 ',
        content: 'In recent times, NBFC interest in the MSME segment has also been fuelled by sustained demand...',
        link: 'https://www.financialexpress.com/industry/sme/nbfcs-expand-msme-portfolios/3136635/',
      },
      {
        Img: 'Adgully.jpg',
        text: 'AdGully',
        Date: 'June 19, 2023',
        link: 'https://www.adgully.com/performics-india-unveils-groundbreaking-trends-in-the-fintech-industry-133174.html',
        content: "Performics India's BFSI & Fintech Immersion Day in Mumbai showcased cutting-edge technologies and...",
      },

      {
        Img: 'economic-time.jpeg',
        text: 'THE ECONOMIC TIMESl',
        Date: 'May 30, 2023',
        content: ' 5 tips to get a personal loan with lowest interest rate and processing fee...',
        link: 'https://m.economictimes.com/wealth/borrow/cheapest-personal-loan-five-tips-to-get-a-personal-loan-with-lowest-interest-rate-and-processing-fee/articleshow/100518826.cms',
      },
      {
        Img: 'fortune.jpeg',
        text: 'Fortune India',
        Date: 'April 10, 2023',
        content: 'InCred is recognized as the employer of the future...',
        link: `https://www.fortuneindia.com/long-reads/incred-all-about-retaining-talent/112195`,
      },
      {
        Img: 'yourstory.png',
        text: 'YOURSTORY',
        Date: 'February 09, 2023',
        content: 'InCred launches InCred Pronto to address monthly financial needs...',
        link: `${BASE_PATH}/docs/YourStory - InCred launches InCred Pronto - 9 February 2023.pdf`,
      },

      {
        Img: 'moneycontrol.jpg',
        text: 'Moneycontrol',
        Date: 'January 17, 2023',
        content: 'Budget 2023: NBFCs hope budget will offer liquidity-enhancement measures...',
        link: `https://www.moneycontrol.com/news/business/budget-2023-nbfcs-hope-budget-will-offer-liquidity-enhancement-measures-9882751.html`,
      },
      {
        Img: 'livemint.jpg',
        text: 'mint',
        Date: 'January 06, 2023',
        content: 'InCred Financial announces public issue of up to ₹350 crore of NCDs...',
        link: `https://www.livemint.com/market/commodities/incred-financial-services-announces-public-issue-of-up-to-rs-350-crore-of-non-convertible-debentures-ncds-11672978533449.html`,
      },
      {
        Img: 'moneycontrol.jpg',
        text: 'Moneycontrol',
        Date: 'January 05, 2023',
        content: 'InCred Financial looking to raise up to Rs 350 crore via NCDs...',
        link: `https://www.moneycontrol.com/news/business/incred-financial-looking-to-raise-up-to-rs-350-crore-via-ncds-9815851.html`,
      },
      {
        Img: 'ecotimes.png',
        text: 'The Economic Times',
        Date: 'January 03, 2023',
        content: 'InCred Financial Services to raise at least Rs 175cr via public issue...',
        link: `https://economictimes.indiatimes.com/markets/stocks/news/incred-financial-services-to-raise-at-least-rs-175-cr-via-public-issue/articleshow/96712771.cms`,
      },
      {
        Img: 'Financial-Express.jpeg',
        text: 'Financial Express',
        Date: 'December 20, 2022',
        content: 'FinTech Innovation: Why NBFCs are at the forefront',
        link: 'https://www.firstpost.com/opinion/fintech-innovation-why-nbfcs-are-at-the-forefront-11836691.html?utm_source=LinkedIn&utm_medium=Website_Traffic&utm_campaign=InCredInNews&utm_id=InCredInNews_FinTechInnovation_Firstpost',
      },
      {
        Img: 'times-of-india-logo.png',
        text: 'Moneycontrol',
        Date: 'September 12, 2022',
        content: 'NBFCs outscore PSBs in NPA-prone education loans',
        link: 'https://www.moneycontrol.com/news/business/startup/bnpl-players-expect-up-to-8x-credit-spike-in-festive-bonanza-despite-rbi-speed-breakers-9163971.html',
      },
      {
        Img: 'moneycontrol.jpg',
        text: 'Times of India',
        Date: 'September 01, 2022',
        content: 'Burden of debt breaks students’ backs',
        link: 'https://timesofindia.indiatimes.com/city/hyderabad/hyderabad-burden-of-debt-breaks-students-backs/articleshow/93896461.cms',
      },
      {
        Img: 'businessweek.png',
        text: 'Business News',
        Date: 'August 19, 2022',
        content: 'InCred teams up with Malnad Falcons as their official partner',
        link: 'http://businessnewsthisweek.com/business/incred-teams-up-with-malnad-falcons-as-their-official-partner-for-the-grand-prix-badminton-league/amp/',
      },
      {
        Img: 'APN.png',
        text: 'APN News',
        Date: 'August 19, 2022',
        content: 'InCred teams up with Malnad Falcons as their official partner',
        link: 'https://www.apnnews.com/incred-teams-up-with-malnad-falcons-as-their-official-partner-for-the-grand-prix-badminton-league/?__cf_chl_tk=sjy7pkKr7yOdPbEgWp2T.xbXIZi77WG3hOiftJ5cqO0-1660889265-0-gaNycGzNCf0',
      },
      {
        Img: 'businesstoday.png',
        text: 'Business Today',
        Date: 'August 05, 2022',
        content: 'RBI Monetary Policy Highlights: Rbi Hikes Repo Rate by 50 bps',
        link: 'https://www.businesstoday.in/markets/stocks/story/share-market-update-sensex-rises-89-pts-nifty-ends-flat-ultratech-icici-bank-gain-343786-2022-08-05',
      },
      {
        Img: 'livemint.jpg',
        text: 'Mint',
        Date: 'August 05, 2022',
        content: 'RBI Monetary Policy Highlights: Rbi Hikes Repo Rate by 50 bps',
        link: 'https://www.livemint.com/market/live-blog/share-market-live-updates-sensex-nifty-bse-nse-stock-market-today-05-08-2022-11659659982618.html',
      },
      {
        Img: 'Financial-Express.jpeg',
        text: 'inancial Express',
        Date: 'August 01, 2022',
        content: 'Borrowings | Student loans: Do the math first',
        link: 'https://www.financialexpress.com/money/borrowings-student-loans-do-the-math-first/2612561/',
      },
      {
        Img: 'business-std.png',
        text: 'Business Standard',
        Date: 'July 31, 2022',
        content: 'Borrowings | Student loans: Do the math first',
        link: `${BASE_PATH}/docs/BS Education Loan.pdf`,
      },
      {
        Img: 'business-std.png',
        text: 'Business Standard',
        Date: 'July 31, 2022',
        content: 'Tackle higher cost of foreign education with diligent planning',
        link: `${BASE_PATH}/docs/BS Education Loan.pdf`,
      },
      {
        Img: 'times-of-india-logo.png',
        text: 'Business Standard',
        Date: 'July 28, 2022',
        content: 'InCred and KKR India Financial Services Complete Merger',
        link: `https://timesofindia.indiatimes.com/business/startups/companies/incred-and-kkr-india-financial-services-complete-merger/articleshow/93179204.cms?UTM_Source=Google_Newsstand&UTM_Campaign=RSS_Feed&UTM_Medium=Referral`,
      },
      {
        Img: 'vccircle-logo.png',
        text: 'VC Circle',
        Date: 'July 27, 2022',
        content: 'KKR India Financial Services completes merger with InCred Finance',
        link: `https://www.vccircle.com/kkr-india-financial-services-completes-merger-with-incred-finance`,
      },
      {
        Img: 'Business Insider India.jpg',
        text: 'Bussiness Insider',
        Date: 'July 27, 2022',
        content: "InCred, KKR India Financial Services complete merger, hope to become a 'leading' NBFC",
        link: `https://www.businessinsider.in/business/corporates/news/incred-and-kkr-india-financial-services-complete-their-merger/articleshow/93155739.cms`,
      },
      {
        Img: 'moneycontrol.jpg',
        text: 'Moneycontrol',
        Date: 'July 27, 2022',
        content: 'InCred, KKR India Financial Services conclude strategic merger to launch InCred Finance',
        link: `https://www.moneycontrol.com/news/business/mergers-acquisitions/incred-kkr-india-financial-services-conclude-strategic-merger-to-launch-incred-finance-8898681.html`,
      },
      {
        Img: 'jagran.png',
        text: 'Dainik Jagran',
        Date: 'June 27, 2022',
        content: '5 Education Loan terminologies simplified',
        link: `https://www.jagran.com/business/expert-column-understand-5-vocabulary-related-to-education-loan-in-easy-language-22835128.html`,
      },
      {
        Img: 'financial_express.png',
        text: 'Financial Express',
        Date: 'June 24, 2022',
        content: 'How will RBI rate hikes impact your loan EMIs?',
        link: `https://www.financialexpress.com/money/how-will-rbi-rate-hikes-impact-your-loan-emis/2572017/`,
      },
      {
        Img: 'zeebusiness.png',
        text: 'Zee Buisness',
        Date: ' June 9, 2022',
        content: 'RBI Monetary Policy Meeting June 2022 Outcome',
        link: `https://www.zeebiz.com/india/news-rbi-monetary-policy-meeting-june-2022-outcome-what-experts-say-about-mpc-review-live-updates-186649`,
      },
      {
        Img: 'times-of-india-logo.png',
        text: 'Times of India',
        Date: 'June 9, 2022',
        content: "Explainer: What are RBI's new norms for large NBFCs?",
        link: `https://timesofindia.indiatimes.com/business/india-business/explainer-what-are-rbis-new-norms-for-large-nbfcs-/articleshow/92071537.cms`,
      },
      {
        Img: 'ATT-M-Logo.png',
        text: 'All Things HR',
        Date: 'Apr 26, 2022',
        content: 'InCred’s Group Head-HR on their own IPL, Inclusive Selection Of Managers',
        link: `https://allthingstalent.org/2022/04/26/increds-group-head-hr-on-their-own-ipl-inclusive-hiring-practice-and-more/`,
      },

      {
        Img: 'financial_express.png',
        text: 'Financial Express',
        Date: 'February 15, 2022',
        content: 'Consumer Finance: The changes that may affect you in 2022',
        link: `https://www.financialexpress.com/money/consumer-finance-the-changes-that-may-affect-you-in-2022/2435117/`,
      },
      {
        Img: 'news18.png',
        text: 'News18',
        Date: 'February 1, 2022',
        content: 'Income Tax Budget LIVE Updates',
        link: `https://www.news18.com/news/business/budget-2022-income-tax-slabs-live-updates-income-tax-calculator-pension-senior-citizen-pf-standard-deduction-fm-sitharaman-income-tax-changes-in-union-budget-livenews-4720043.html`,
      },
      {
        Img: 'news18.png',
        text: 'News18',
        Date: 'January 31, 2022',
        content: 'Union Budget 2022 Session Schedule Announced: Check Date, Time, Key Details',
        link: `https://www.news18.com/news/business/union-budget-2022-check-date-time-and-other-key-details-4656428.html`,
      },
      {
        Img: 'indiantelivision.png',
        text: 'Indian Television',
        Date: ' December 29, 2021',
        content: 'InCred celebrates the spirit of 83',
        link: `https://www.adgully.com/incred-celebrates-the-spirit-of-83-112594.html?amp=1`,
      },
      {
        Img: 'CXO-Outlook_Trade-marked.png',
        text: 'CXOOutlook',
        Date: ' December 28, 2021',
        content: 'InCred celebrates the spirit of 83',
        link: `https://www.cxooutlook.com/incred-celebrates-the-spirit-of-83/`,
      },
      {
        Img: 'CXO-Outlook_Trade-marked.png',
        text: 'CXOOutlook',
        Date: ' December 28, 2021',
        content: 'InCred celebrates the spirit of 83',
        link: `https://www.cxooutlook.com/incred-celebrates-the-spirit-of-83/`,
      },
      {
        Img: 'financial_express.png',
        text: 'The Financial Express ',
        Date: ' October 22, 2021',
        content: 'Personal Loan vs Loan against PPF: Which one should you opt for?',
        link: `https://www.financialexpress.com/money/personal-loan-vs-loan-against-ppf-which-one-should-you-opt-for/2355020/`,
      },
      {
        Img: 'buisness-standard.png',
        text: 'Business Standard',
        Date: 'September 30, 2021',
        content: 'Prevent auto-debit failures by registering once again, say experts',
        link: `https://www.business-standard.com/article/pf/prevent-auto-debit-failures-by-registering-once-again-say-experts-121093001302_1.html`,
      },
      {
        Img: 'livemint.jpg',
        text: 'Livemint',
        Date: 'September 24, 2021',
        content: 'How to manage your debt so it doesn’t become a burden',
        link: `https://www.livemint.com/companies/news/zomato-incred-collaborate-for-loans-with-no-processing-fee-to-restaurants-11631868522752.html`,
      },
      {
        Img: 'livemint.jpg',
        text: 'Livemint',
        Date: 'September 17, 2021',
        content: 'Zomato, InCred collaborate for loans with no processing fee to restaurants',
        link: `https://www.livemint.com/companies/news/zomato-incred-collaborate-for-loans-with-no-processing-fee-to-restaurants-11631868522752.html`,
      },
      {
        Img: 'buisness-standard.png',
        text: 'Business Standard',
        Date: 'September 06, 2021',
        content: 'Studying abroad? How to choose the right lender type for an education loan',
        link: `https://wap.business-standard.com/article/pf/studying-abroad-how-to-choose-the-right-lender-type-for-an-education-loan-121090301091_1.html`,
      },
      {
        Img: 'times-of-india-logo.png',
        text: 'The Times of India',
        Date: ' August 17, 2021',
        content: 'KKR corp loans unit merges with InCred Fin',
        link: `https://timesofindia.indiatimes.com/business/india-business/kkr-corp-loans-unit-merges-with-incred-fin/articleshow/85394584.cms`,
      },

      {
        Img: 'ecotimes.png',
        text: 'The Economic Times',
        Date: 'August 17, 2021',
        content: 'InCred, KKR merge NBFCs in all-stock deal, combined entity InCred Fin will have $300m equity base',
        link: `https://economictimes.indiatimes.com/industry/banking/finance/banking/incred-kkr-merge-nbfcs-in-all-stock-deal/articleshow/85382428.cms?utm_source=contentofinterest&utm_medium=text&utm_campaign=cppst`,
      },
      {
        Img: 'livemint.jpg',
        text: 'Livemint',
        Date: 'August 17, 2021',
        content: 'KKR India Fin Services and InCred ink deal to merge their lending biz',
        link: `https://www.livemint.com/companies/news/incred-finance-kkr-india-financial-services-ink-merger-deal-116291225998buisness-standard.html`,
      },
      {
        Img: 'CXO-Outlook_Trade-marked.png',
        text: 'The Economic Times',
        Date: 'August 17, 2021',
        content: 'InCred, KKR merge NBFCs in all-stock deal, combined entity InCred Fin will have $300m equity base',
        link: `https://economictimes.indiatimes.com/industry/banking/finance/banking/incred-kkr-merge-nbfcs-in-all-stock-deal/articleshow/85382428.cms?utm_source=contentofinterest&utm_medium=text&utm_campaign=cppst`,
      },
      {
        Img: 'ecotimes.png',
        text: 'CXOOutlook',
        Date: 'August 04, 2021',
        content: 'InCred Financial Services closes second issue of covered bond for $10 mn',
        link: `https://www.cxooutlook.com/incred-takes-another-step-towards-funding-diversification-with-the-closure-of-its-second-covered-bond-at-rs-75-crores/`,
      },
      {
        Img: 'vccircle-logo.png',
        text: 'VCCircle',
        Date: 'August 04, 2021',
        content: 'InCred Financial Services closes second issue of covered bond for $10 mn',
        link: `https://www.vccircle.com/incred-financial-services-closes-second-issue-of-covered-bond-for-10-mn`,
      },
      {
        Img: 'CXO-Outlook_Trade-marked.png',
        text: 'CXOOutlook',
        Date: 'July 27, 2021',
        content: 'Amazon India, InCred join hands to offer credit to e-commerce retailers',
        link: `https://www.cxooutlook.com/amazon-in-and-incred-join-hands-to-offer-hassle-free-credit-to-e-commerce-sellers-retailers/`,
      },
      {
        Img: 'Picture2.png',
        text: 'India Retailer',
        Date: 'July 27, 2021',
        content: 'Amazon India, InCred join hands to offer credit to e-commerce retailers',
        link: `https://www.indianretailer.com/news/amazon-to-address-financial-constraints-of-indian-e-tailers.n11231/`,
      },
      {
        Img: 'bsjournal.png',
        text: 'Business Journal',
        Date: 'July 27, 2021',
        content: 'Amazon India, InCred join hands to offer credit to e-commerce retailers',
        link: `https://business-journal.in/small-biz/amazon-india-incred-join-hands-to-offer-credit-to-e-commerce-retailers-business-journal/`,
      },
      {
        Img: 'techcircle.jpg',
        text: 'TechCircle',
        Date: 'July 27, 2021',
        content: 'Amazon India, InCred join hands to offer credit to e-commerce retailers',
        link: `https://www.indianretailer.com/news/amazon-to-address-financial-constraints-of-indian-e-tailers.n11231/`,
      },
      {
        Img: 'ecotimes.png',
        text: 'The Economic Times',
        Date: 'July 27, 2021',
        content: 'Amazon India, InCred join hands to offer credit to e-commerce retailers',
        link: `https://www.indianretailer.com/news/amazon-to-address-financial-constraints-of-indian-e-tailers.n11231/`,
      },

      {
        Img: 'buisness-standard.png',
        text: 'Business Standard',
        Date: 'July 05, 2021',
        content: "We do have banking ambitions, says Incred Group's Bhupinder Singh",
        link: `https://www.business-standard.com/article/finance/we-do-have-banking-ambitions-says-incred-group-s-bhupinder-singh-121070400711_1.html`,
      },

      {
        Img: 'cnbc-logo.png',
        text: 'CNBCTV18',
        Date: ' July 03, 2021',
        content: 'Story on touchless personal loan',
        link: `https://www.cnbctv18.com/personal-finance/looking-to-get-touchless-personal-loan-online-here-are-key-things-to-know-9860481.html`,
      },
      {
        Img: 'bw_disrupt.png',
        text: 'Banking Frontier',
        Date: ' May 28, 2021',
        content: 'Cover Story of Prithvi',
        link: `https://www.cnbctv18.com/personal-finance/looking-to-get-touchless-personal-loan-online-here-are-key-things-to-know-9860481.html`,
      },
      {
        Img: 'APN.png',
        text: 'APN News',
        Date: ' May 28, 2021',
        content: 'Catching the wave – Technological disruptions for an era of uncertainty',
        link: `http://mediabulletins.com/business-world/catching-the-wave-technological-disruptions-for-an-era-of-uncertainty/http://mediabulletins.com/business-world/catching-the-wave-technological-disruptions-for-an-era-of-uncertainty/`,
      },
      {
        Img: 'bw_disrupt.png',
        text: 'BusinessWorld',
        Date: 'May 20, 2021',
        content: "United We Stand' - Brands Helping India Fight Against COVID-19",
        link: `http://bwdisrupt.businessworld.in/article/-United-We-Stand-Brands-Helping-India-Fight-Against-COVID-19/18-05-2021-390091/`,
      },
      {
        Img: 'startup-success-stories-png.png',
        text: 'BusinessWorld',
        Date: 'May 19, 2021',
        content: 'InCred Partners with IAHV – The Art of Living and Hemkunt Foundation for Supporting Supply of oxygen, medicine and equipment',
        link: `https://startupsuccessstories.in/incred-partners-with-iahv-the-art-of-living-and-hemkunt-foundation-for-supporting-supply-of-oxygen-medicine-and-equipment/`,
      },
      {
        Img: 'CXO-Outlook_Trade-marked.png',
        text: 'BusinessWorld',
        Date: 'May 18, 2021',
        content: 'InCred Partners with IAHV – The Art of Living and Hemkunt Foundation for Supporting Supply of oxygen, medicine and equipment',
        link: `https://www.cxooutlook.com/incred-partners-with-iahv-the-art-of-living-and-hemkunt-foundation-for-supporting-supply-of-oxygen-medicine-and-equipment/`,
      },
      {
        Img: 'Adgully.jpg',
        text: 'Adgully',
        Date: 'May 17, 2021',
        content: 'InCred Partners with IAHV – The Art of Living and Hemkunt Foundation for Supporting Supply of oxygen, medicine and equipment',
        link: `https://www.adgully.com/incred-partners-with-iahv-103802.html`,
      },
      {
        Img: 'financial_express.png',
        text: 'Financial Express',
        Date: 'May 13, 2021',
        content: 'New Age Investments: What helps millennials grow financially?',
        link: `https://www.adgully.com/incred-partners-with-iahv-103802.html`,
      },
      {
        Img: 'livemint.jpg',
        text: 'Livemint',
        Date: ' April 9, 2021',
        content: 'Can you get a personal loan with a low credit score?',
        link: `https://www.livemint.com/money/personal-finance/can-you-get-a-personal-loan-with-a-low-credit-score-11617959313552.html`,
      },
      {
        Img: 'moneycontrol.jpg',
        text: 'Livemint',
        Date: ' April 9, 2021',
        content: 'I feel we will see normalisation in markets where prices will follow earnings: Nitin Rao of InCred Wealth',
        link: `https://www.moneycontrol.com/news/business/markets/pms-offers-a-more-flexible-framework-hnis-should-consider-some-investments-in-alternative-assets-too-says-nitin-rao-of-incred-wealth-6722421.html`,
      },
      {
        Img: 'sillicon.png',
        text: 'Silicon India',
        Date: ' April 1, 2021',
        content: 'The changing role of CTOs in 2021',
        link: `https://technology.siliconindia.com/viewpoint/cxoinsights/the-changing-role-of-ctos-in-2021-nwid-27401.html`,
      },
      {
        Img: 'livemint.jpg',
        text: 'Livemint',
        Date: ' March 9, 2021',
        content: 'Line of credit and how it works?',
        link: `https://www.livemint.com/money/personal-finance/line-of-credit-and-how-it-works-11615355387443.html`,
      },
      {
        Img: 'livemint.jpg',
        text: 'Livemint',
        Date: 'March 8, 2021',
        content: "International women's day: Fundraising tips for women entrepreneurs",
        link: `https://economictimes.indiatimes.com/small-biz/entrepreneurship/international-womens-day-fundraising-tips-for-women-entrepreneurs/articleshow/81385482.cms`,
      },

      {
        Img: 'dailyhunt.jpg',
        text: 'Financial Express',
        Date: 'February 11, 2021',
        content: 'Where should young investors invest in 2021?',
        link: `https://technology.siliconindia.com/viewpoint/cxoinsights/the-changing-role-of-ctos-in-2021-nwid-27401.html`,
      },

      {
        Img: 'sillicon.png',
        text: 'Daily Hunt',
        Date: 'February 5, 2021',
        content: 'Have a complaint against bank or NBFC or digital wallet? RBI to soon roll out a unified ombudsman',
        link: `https://m.dailyhunt.in/news/india/english/money+control+english-epaper-mconten/have+a+complaint+against+bank+or+nbfc+or+digital+wallet+rbi+to+soon+roll+out+a+unified+ombudsman-newsid-n251644384`,
      },
      {
        Img: 'moneycontrol.jpg',
        text: 'Money Control',
        Date: 'February 5, 2021',
        content: 'Have a complaint against bank or NBFC or digital wallet? RBI to soon roll out a unified ombudsman',
        link: `https://www.moneycontrol.com/news/business/personal-finance/have-a-complaint-against-bank-or-nbfc-or-digital-wallet-rbi-to-soon-roll-out-a-unified-ombudsman-6458891.html`,
      },
      {
        Img: 'Adgully.jpg',
        text: 'Adgully',
        Date: 'February 2, 2021',
        content: 'This Budget truly has the potential for transforming India: Start-ups hail Budget boost',
        link: `https://www.adgully.com/this-budget-truly-has-the-potential-for-transforming-india-start-ups-hail-budget-boost-100497.html`,
      },
      {
        Img: 'techshots.jpg',
        text: 'Techshotapp',
        Date: 'January 23, 2021',
        content: 'InCred Finance ropes in Philipp Orgler to spearhead AI and ML capabilities',
        link: `https://techshotsapp.com/2021/01/23/incred-finance-hires-philipp-orgler-for-ai-and-ml-tools-development/`,
      },
      {
        Img: 'Hrnxt.png',
        text: 'Techshotapp',
        Date: 'January 23, 2021',
        content: 'InCred Finance ropes in Philipp Orgler to spearhead AI and ML capabilities',
        link: `https://business-journal.in/technology/incred-finance-ropes-in-philipp-orgler-to-spearhead-ai-and-ml-capabilities-business-journal/`,
      },
      {
        Img: 'smartnews.png',
        text: 'Techshotapp',
        Date: 'January 23, 2021',
        content: 'InCred Finance ropes in Philipp Orgler to spearhead AI and ML capabilities',
        link: `https://www.smartnews.business/incred-finance-ropes-in-philipp-orgler-to-spearhead-ai-and-ml-capabilities/`,
      },
      {
        Img: 'Hrnxt.png',
        text: 'Techshotapp',
        Date: 'January 23, 2021',
        content: 'InCred Finance ropes in Philipp Orgler to spearhead AI and ML capabilities',
        link: `https://business-journal.in/technology/incred-finance-ropes-in-philipp-orgler-to-spearhead-ai-and-ml-capabilities-business-journal/`,
      },
      {
        Img: 'economictimes.png',
        text: 'Techshotapp',
        Date: 'January 23, 2021',
        content: 'InCred Finance ropes in Philipp Orgler to spearhead AI and ML capabilities',
        link: `https://cio.economictimes.indiatimes.com/news/corporate-news/incred-finance-ropes-in-philipp-orgler-to-spearhead-ai-and-ml-capabilities/80417396`,
      },
      {
        Img: 'tech-news-flag.jpg',
        text: 'Techshotapp',
        Date: 'January 23, 2021',
        content: 'InCred Finance ropes in Philipp Orgler to spearhead AI and ML capabilities',
        link: `https://newsof-india.com/incred-finance-ropes-in-philipp-orgler-to-spearhead-ai-and-ml-capabilities/`,
      },
      {
        Img: 'newsjournal.png',
        text: 'Techshotapp',
        Date: 'January 23, 2021',
        content: 'InCred Finance ropes in Philipp Orgler to spearhead AI and ML capabilities',
        link: `https://newsjournals.in/incred-finance-ropes-in-philipp-orgler-to-spearhead-ai-and-ml-capabilities/`,
      },
      // {
      //     Img: 'humancapital.gif',
      //     text: 'Techshotapp',
      //     Date:'January 22, 2021',
      //     content:"InCred Finance ropes in Philipp Orgler to spearhead AI and ML capabilities",
      //     link:`https://humancapitalonline.com/News/details/2005/InCred%20Ropes%20In%20Philipp%20Orgler%20to%20bolster%20Analytics%20expertise`
      // },
      {
        Img: 'techcircle.jpg',
        text: 'Techshotapp',
        Date: 'January 22, 2021',
        content: 'InCred Finance ropes in Philipp Orgler to spearhead AI and ML capabilities',
        link: `https://www.techcircle.in/2021/01/22/incred-appoints-philipp-orgler-to-lead-ai-ml-development`,
      },
      {
        Img: 'economic_times.png',
        text: 'Techshotapp',
        Date: 'January 22, 2021',
        content: 'InCred Finance ropes in Philipp Orgler to spearhead AI and ML capabilities',
        link: `https://economictimes.indiatimes.com/tech/tech-bytes/incred-finance-ropes-in-philipp-orgler-to-spearhead-ai-and-ml-capabilities/articleshow/80401165.cms`,
      },
      {
        Img: 'ET.png',
        text: 'Techshotapp',
        Date: 'January 22, 2021',
        content: 'InCred Finance ropes in Philipp Orgler to spearhead AI and ML capabilities',
        link: `https://hr.economictimes.indiatimes.com/news/industry/incred-finance-ropes-in-philipp-orgler-to-spearhead-ai-and-ml-capabilities/80407611`,
      },
    ],
  },
  {
    label: 'Press Release',
    data: [
      {
        Img: 'incred.png',
        text: 'Press release',
        Date: 'January 25, 2024',
        content: `InCred Finance's core Loan book witnessed a stupendous 55% YoY growth crossing INR 8,000 Cr in Dec-23. `,
        link: `${ASSET_DOMAIN_URL}/doc/news/Press Release - IFSL Q3 FY24 Result_Final approved.pdf`,
      },
      {
        Img: 'incred.png',
        text: 'Press release',
        Date: 'November 06, 2023',
        content: `InCred Forecasts 15-20% Annual Growth in India's Consumer Lending, Despite Small Ticket Personal Loan Challenges.`,
        link: `${ASSET_DOMAIN_URL}/doc/news/23.12.05 InCred PL RoundTable Press Note.pdf`,
      },
      {
        Img: 'incred.png',
        text: 'Press release',
        Date: 'November 09, 2023',
        content: 'InCred’s lending business secures INR 500 Crores commitments for Series D Funding, to enter Unicorn Club.',
        link: `${ASSET_DOMAIN_URL}/doc/news/Press Release InCred Finance Secures INR 500 Crores commitments for Series D Funding_9 Nov 2023.pdf`,
      },
      {
        Img: 'incred.png',
        text: 'Press release',
        Date: 'October 13, 2023',
        content: 'InCred Financial Services Limited announces Public Issue of up to ₹300 crore of Secured NCDs',
        link: `${ASSET_DOMAIN_URL}/doc/news/NCD press release.pdf`,
      },
      {
        Img: 'incred.png',
        text: 'Press release',
        Date: 'April 05, 2023',
        content: 'InCred is recognized as the employer of the future...',
        link: 'https://www.moneycontrol.com/news/business/budget-2023-nbfcs-hope-budget-will-offer-liquidity-enhancement-measures-9882751.html',
      },

      {
        Img: 'incred.png',
        text: 'Press release',
        Date: 'January 05, 2023',
        content: 'InCred Financial looking to raise up to Rs 350 crore via NCDs',
        link: 'https://www.moneycontrol.com/news/business/incred-financial-looking-to-raise-up-to-rs-350-crore-via-ncds-9815851.html',
      },
      {
        Img: 'incred.png',
        text: 'Press release',
        Date: ' February 01, 2023',
        content: 'Vivek Bansal, Group CFO shares his Union Budget Expectations 2023...',
        link: 'https://www.moneycontrol.com/news/business/budget-2023-nbfcs-hope-budget-will-offer-liquidity-enhancement-measures-9882751.html',
      },
      {
        Img: 'incred.png',
        text: 'Press release',
        Date: 'January 05, 2023',
        content: 'InCred Financial Services Limited announces Public Issue of up to ₹ 350 crore of Secured, Redeemable NCDs...',
        link: `${BASE_PATH}/docs/Incred Final NCD Release 5.1.2023 (1).pdf`,
      },
      {
        Img: 'incred.png',
        text: 'Press release',
        Date: 'August 26, 2022',
        content: 'CRISIL & CARE assign ratings of CRISIL A+ & CARE A+ to InCred Finance...',
        link: `${BASE_PATH}/docs/Press Release - CRISIL and CARE assign ratings of CRISIL A+ and CARE A+ to InCred Finance.pdf`,
      },

      {
        Img: 'incred.png',
        text: 'Press release',
        Date: 'August 26, 2022',
        content: 'CRISIL & CARE assign ratings of CRISIL A+ & CARE A+ to InCred Finance...',
        link: `${BASE_PATH}/docs/Press Release - CRISIL and CARE assign ratings of CRISIL A+ and CARE A+ to InCred Finance.pdf`,
      },
      {
        Img: 'incred.png',
        text: 'Press release',
        Date: 'July 26, 2022',
        content: 'InCred and KKR India Financial Services complete merger',
        link: `${BASE_PATH}/docs/KKR - Merger.pdf`,
      },
    ],
  },
];

export default incredNews;
